import { render, staticRenderFns } from "./homeMenu.vue?vue&type=template&id=737aadbe&scoped=true"
import script from "./homeMenu.vue?vue&type=script&lang=js"
export * from "./homeMenu.vue?vue&type=script&lang=js"
import style0 from "./homeMenu.vue?vue&type=style&index=0&id=737aadbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737aadbe",
  null
  
)

export default component.exports